import { PrimitiveMeshAttributes, CLIP_TWEEN_DURATION } from "./PrimitiveMeshInstanceShader";
import { now } from "../../../../messages/timing";
// An Instanced version of Three Mesh
export class PrimitiveMeshInstance {
    constructor(batch, instanceIndex) {
        this.batch = batch;
        this.instanceIndex = instanceIndex;
    }
    isValid() {
        return this.batch && this.instanceIndex !== -1;
    }
    get mesh() {
        return this.batch.getMesh();
    }
    get geometry() {
        return this.batch.geometry;
    }
    get visible() {
        if (this.isValid()) {
            return this.isVisible();
        }
        return false;
    }
    set visible(value) {
        if (this.isValid()) {
            this.setVisible(value);
        }
    }
    isVisible() {
        return this.batch.isVisibleAt(this.instanceIndex);
    }
    setVisible(value) {
        this.batch.setVisibleAt(this.instanceIndex, value);
    }
    // World position
    setPosition(pos) {
        this.batch.setVector3AttributeAt(PrimitiveMeshAttributes.position, this.instanceIndex, pos);
    }
    // World position
    getPosition(pos) {
        this.batch.getVector3AttributeAt(PrimitiveMeshAttributes.position, this.instanceIndex, pos);
    }
    // World scale
    setScale(scale) {
        this.batch.setVector3AttributeAt(PrimitiveMeshAttributes.scale, this.instanceIndex, scale);
    }
    // World scale
    getScale(scale) {
        this.batch.getVector3AttributeAt(PrimitiveMeshAttributes.scale, this.instanceIndex, scale);
    }
    // World orientation
    setOrientation(q) {
        this.batch.setQuaternionAttributeAt(PrimitiveMeshAttributes.orientation, this.instanceIndex, q);
    }
    // World orientation
    getOrientation(q) {
        this.batch.getQuaternionAttributeAt(PrimitiveMeshAttributes.orientation, this.instanceIndex, q);
    }
    setColor(color) {
        this.batch.setColorAttributeAt(PrimitiveMeshAttributes.color, this.instanceIndex, color);
    }
    getColor(color) {
        this.batch.getColorAttributeAt(PrimitiveMeshAttributes.color, this.instanceIndex, color);
    }
    // fade the instance in/out.
    // target=0 => fade in
    // target=1 => fade until center of instance
    // target=2 => fade out
    setClipFade(target) {
        const oldTarget = this.batch.getYOfAttributeAt(PrimitiveMeshAttributes.clipFade, this.instanceIndex);
        if (target === oldTarget) {
            // old target is the same as the new target so we don't need to change the annimation
            return;
        }
        let s;
        const oldSource = this.batch.getXOfAttributeAt(PrimitiveMeshAttributes.clipFade, this.instanceIndex);
        const oldUntil = this.batch.getZOfAttributeAt(PrimitiveMeshAttributes.clipFade, this.instanceIndex);
        const currentTime = now();
        const until = currentTime + CLIP_TWEEN_DURATION;
        if (currentTime > oldUntil) {
            // no animation currently -> the old animation has already reached its traget
            // so we have to start the new animation from the target of the old animation
            s = oldTarget;
        }
        else {
            // annimation currently active so we have to calulate the curret position
            // of the animation and start our new animation from there.
            // reverse interpolate to get the current position
            const remaining = oldUntil - currentTime;
            const interpolate = 1.0 - remaining / CLIP_TWEEN_DURATION;
            s = oldSource * (1.0 - interpolate) + oldTarget * interpolate;
            // substract the remaining time from the animation time
            // substracting the remaining time of the old animation from the animation time leads to jumps in the animation since we don't start the new animation at 0.0.
            // until -= remaining;
        }
        this.batch.setAttributeAt(PrimitiveMeshAttributes.clipFade, this.instanceIndex, [s, target, until]);
    }
    destroy() {
        this.batch.deleteInstance(this);
    }
}
